// The shared "position" cell of a tournament standings row: position number plus
// the team logo / name / country block. Used by both the desktop and mobile
// standings tables.
// Args:
//   @position - position text (e.g. '01', or the loop index for the desktop table)
//   @logo     - team logo src
//   @name     - team name
//   @country  - team country
//   @alt      - logo alt text
<template>
  <div class='table-row-item position'>
    <p class='table-text'>{{@position}}</p>
    <div class='team-info-wrap'>
      <img class='team-logo small' src={{@logo}} alt={{@alt}} />
      <div class='team-info'>
        <p class='team-name'>{{@name}}</p>
        <p class='team-country'>{{@country}}</p>
      </div>
    </div>
  </div>
</template>
